import React from 'react';
import { useTranslation } from 'react-i18next';
import { GarageDetailsContactProps } from 'pages/MyNetworkPage/GarageDetails/GarageDetails.types';
import { DetailsSection, SFlexWrapper } from 'pages/MyNetworkPage/GarageDetails/GarageDetailsPage.styled';
import { Flex, Text } from 'UI';
import { textFormatter } from 'utils';

export const GarageDetailsContact: React.FC<GarageDetailsContactProps> = ({ garageDetails }) => {
  const { t } = useTranslation();

  return (
    <SFlexWrapper direction={'column'} gap={15}>
      <Text type={'h4_paragraph'}>{t('profile.my_network.garage_details.contact_details', 'Contact details')}</Text>
      <DetailsSection direction={'row'} gap={10}>
        <Flex direction={'column'}>
          <Text type="base" color="grey55">
            {t('my_network.garage_details.membership_start_date', 'Membership start date')}
          </Text>
          <Text type="base" color="grey55">
            {t('my_network.garage_details.membership_end_date', 'Membership end date')}
          </Text>
        </Flex>
        <Flex direction={'column'} align={'flex-end'} padding={'0 30px 0 0'}>
          <Text type="base" color="grey55">
            {garageDetails?.startDate && textFormatter.formatTime(new Date(garageDetails.startDate))}
          </Text>
          <Text type="base" color="grey55">
            {garageDetails?.endDate && textFormatter.formatTime(new Date(garageDetails.endDate))}
          </Text>
        </Flex>
      </DetailsSection>
      <DetailsSection direction={'column'} gap={10}>
        <Text type="base" bold>
          {garageDetails?.companyName}
        </Text>
        <Text type={'text'}>
          {[
            garageDetails?.address?.addressLine1,
            garageDetails?.address?.addressLine2,
            garageDetails?.address?.addressLine3,
          ]
            .filter(Boolean)
            .join(' ')}
        </Text>
        <Text type={'text'}>
          {[garageDetails?.address?.postalCode, garageDetails?.address?.city].filter(Boolean).join(' ')}
        </Text>
        {garageDetails?.address?.phone && (
          <Text type={'text'}>
            {t('my_network.garage_details.tel', 'Tel')}: {garageDetails.address.phone}
          </Text>
        )}
        {garageDetails?.address?.email && <Text type={'text'}>{garageDetails.address.email}</Text>}
        {garageDetails?.billingAccount && (
          <Text type={'text'}>
            {t('my_network.garage_details.client_code', 'Client code')}: {garageDetails.billingAccount}
          </Text>
        )}
      </DetailsSection>
    </SFlexWrapper>
  );
};
